import { render, staticRenderFns } from "./ViewControler.vue?vue&type=template&id=019215d2"
import script from "./ViewControler.vue?vue&type=script&lang=js"
export * from "./ViewControler.vue?vue&type=script&lang=js"
import style0 from "./ViewControler.vue?vue&type=style&index=0&id=019215d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports